import { makeStyles } from '@material-ui/core/styles'
import React, { useState } from 'react'
import { AutoCompleteInput } from 'src/components/BuyPolicy/common/AutoCompleteInput'
import { TextField } from '@mui/material'
import { REGISTRATION_LOCATIONS } from 'src/utils/constants/BuyPolicy'
import Button from '@mui/material/Button'

const RtoDetails = ({
  carDetails,
  // buyInsuranceType,
  handleChange,
  // onSubmit,
}) => {
  const classes = useStyles()

  const [rtoDetails, setRtoDetails] = useState({
    rtoLocation: carDetails?.rtoLocation,
    registrationDate: carDetails?.registrationDate,
  })

  const handleNext = () => {
    handleChange({ ...rtoDetails })
  }

  const handleRtoLocationChange = (newValue) => {
    setRtoDetails({
      ...rtoDetails,
      rtoLocation: newValue,
    })
  }

  const handleRegistrationDateChange = (event) => {
    setRtoDetails({
      ...rtoDetails,
      registrationDate: event?.target?.value,
    })
  }

  const handleLocations = (option) => option?.name || ''

  return (
    <div className={classes.mainContainer}>
      <div>
        <div className={classes.heading}>
          <span className={classes.headingContent}>RTO Location</span>
        </div>
        <div className={classes.inputContainer}>
          <div className={classes.inputContent}>
            <AutoCompleteInput
              id='AutoCompleteInput'
              optionList={REGISTRATION_LOCATIONS}
              handleOptionLabel={handleLocations}
              placeholder='Search'
              displayEmpty
              value={rtoDetails.rtoLocation}
              handleChange={(event, newValue) =>
                handleRtoLocationChange(newValue)
              }
              label='RTO Location'
              nameLabel='rtoLocation'
              className={`${classes.inputTextField} ${classes.autocompleteField}`}
            ></AutoCompleteInput>
          </div>
        </div>
      </div>

      <div>
        <div className={classes.headingDate}>
          <span className={classes.headingContent}>Registration Date</span>
        </div>
        <div className={classes.inputContainer}>
          <div className={classes.inputContent}>
            <TextField
              id='TextField'
              type='date'
              placeholder='date of birth'
              value={rtoDetails.registrationDate}
              displayEmpty
              onChange={(event) => handleRegistrationDateChange(event)}
              // label='Date Of Birth'
              nameLabel='dateOFBirth'
              className={`${classes.inputTextField} ${classes.dobField}`}
            ></TextField>
          </div>
        </div>
        {/* Date field*/}
      </div>

      <div className={classes.actionsContainer}>
        <Button
          variant='contained'
          onClick={handleNext}
          className={classes.nextButton}
          id='Button'
        >
          Next
        </Button>
      </div>
    </div>
  )
}

export default RtoDetails

const useStyles = makeStyles({
  mainContainer: {
    padding: '10px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '10px',
    marginBottom: '132px',
  },
  dobField: {
    '&  .MuiOutlinedInput-input': {
      height: '0.7rem',
    },
  },
  heading: {
    width: '100%',
    textAlign: 'center',
    marginTop: '-25px',
  },
  autocompleteField: {
    '&  .MuiSvgIcon-root': {
      display: 'none',
    },
  },
  headingDate: {
    width: '100%',
    textAlign: 'center',
  },
  inputContainer: {
    display: 'flex',
    marginBottom: '12px',
    marginTop: '10px',
    minWidth: '213px',
  },
  inputContent: {
    width: '100%',
  },
  inputTextField: {
    borderRadius: '5px !important',
    backgroundColor: 'white !important',
    fontSize: '12px !important',
    fontFamily: 'Roboto !important',
    width: '100%',
  },
  headingContent: {
    fontFamily: 'Roboto',
    fontSize: '16px',
    fontWeight: '400',
  },
  nextButton: {
    background: 'linear-gradient(180deg, #4DC3E3 0%, #1EA0C4 100%) !important',
    color: '#FFFFFF !important',
    fontWeight: '400 !important',
    fontSize: '12px !important',
    fontFamily: 'Roboto !important',
    borderRadius: '5px !important',
  },
})
